import React from 'react'
import NewEvent from './newGeticketsWebsite/Events'

function Events() {
  return (
    <NewEvent/>
  )
}

export default Events